import * as React from "react";
import { useRouteError } from "react-router-dom";
import { ReactComponent as ErrorGeneral } from "../../assets/images/empty-state/error-general.svg";
import { ErrorLayout } from "../../components/layouts/ErrorLayout";
import { getErrorMessageFromError } from "../../utils/errors";

export const ComposeGroupsError = () => {
  const error: any = useRouteError();
  const message = getErrorMessageFromError(error);

  return (
    <ErrorLayout
      overallTitle="Inbox"
      title="An error occurred while loading the Groups Compose dialog."
      subTitle={message}
    >
      <ErrorGeneral />
    </ErrorLayout>
  );
};
